<template lang="pug">
v-app#login_cepi
  
  v-overlay(:value='overlay' opacity='1' z-index='1')

  v-content#login_content
    v-container(fluid='', fill-height='')
      v-layout(align-center='', justify-center='')
        v-flex(xs12='', sm8='', md4='')
          v-card.elevation-12
            v-toolbar(:color='color', dark='', flat='')
              v-toolbar-title Login form {{ msg }}
            v-card-text
              v-form
                v-text-field(label='Login', name='login', prepend-icon='person', type='text', v-model='user')
                v-text-field#password(label='Password', name='password', prepend-icon='lock', type='password' v-model='pass' )
            v-card-actions
              v-spacer
              v-btn(color='primary' @click='login()' :loading="loading") Login

</template>

<script>
  import { config } from '../config.js'


  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      color: 'primary',
      msg: '',
      overlay: true,
      user: '',
      pass: '',
      loading: false
    }),
    methods:{
      login(){
        this.loading = true;
        var user = {
          user: this.user,
          pass: this.pass
        }

        this.axios.post(`${config.serviceUri}login`, {
            name: this.user,
            pass: this.pass
        })
        .then( (response) => {
            localStorage.setItem('user', JSON.stringify(response.data));
            this.color = 'primary'
            this.loading = false;

            this.$router.push({ name: 'home' })
        })
        .catch( (error) => {
            console.log('Error: ', error.response.data);
            this.msg = error.response.data.error;
            this.color = 'error';
            this.loading = false;
        });
      }
    }
  }
</script>

<style scoped>
  #login_content{
    z-index: 4;
  }
</style>
